export const DOWN = 'DOWN';
export const UP = 'UP';
export const DOWN_UP = 'DOWN_UP';
export const UP_DOWN = 'UP_DOWN';
